//
import { RTableHeaders } from '@/components/reusable_components/next'

//
export default RTableHeaders
	.from([
		{
			text: 'folio',
			value: 'dte_number',
			sortable: true,
		},
		{
			text: 'tipo',
			value: 'dte_type',
			align: 'center',
			sortable: true,
		},
		{
			text: 'rut de vendedor',
			value: 'seller_rut',
			//format: 'rut',
			sortable: true,
		},
		{
			text: 'vendedor',
			value: 'seller',
			sortable: true,
		},
		/*{
			text: 'rut de cliente',
			value: 'customer_rut',
			//format: 'rut',
			sortable: true,
		},*/
		{
			text: 'cliente',
			value: 'customer',
			sortable: true,
		},
		{
			text: 'sucursal',
			value: 'customer_branch_offices',
		},
		{
			text: 'estado',
			value: 'status',
			sortable: true,
			align: 'center',
      component: {
        type: "chip-label",
        props: {
        	small: true,
        	palette: {
        		abonado: 'grey darken-3 white--text',
        		atrasado: 'grey darken-3 white--text',
        		boleta_anulada: 'grey darken-4 white--text',
        		esperando_lote: 'grey lighten-3',
        		factura_anulada: 'grey darken-4 white--text',
        		pagado: 'success lighten-3',
        		por_despachar: 'accent lighten-3',
        		por_facturar: 'primary lighten-3',
        		por_pagar: 'info lighten-3',
        		solicitud_anulada: 'error lighten-2',
        		vale_venta: 'secondary lighten-3',
        		venta_anulada: 'error lighten-3',
        	},
        },
      },
		},
		{
			text: 'pagado',
			value: 'paid_amount',
			align: 'right',
			format: 'currency',
			sortable: true,
		},
		{
			text: 'monto',
			value: 'amount',
			align: 'right',
			format: 'currency',
			sortable: true,
		},
		{
			text: 'saldo',
			value: 'balance',
			align: 'right',
			format: 'currency',
			sortable: true,
		},
		{
			text: 'fecha',
			value: 'sale_datetime',
			align: 'right',
			format: 'date',
			sortable: true,
		},
	])